var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content-wrapper",class:{iframe: _vm.isViewiFrame}},[_c('h2',[_vm._v("Potwierdź formularz")]),_c('topup-summary')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }